<template>
  <div class="wrapper clickable">
    <span>
      <a href="#" @click.stop="displayMedia(true)">
        <image-preview :src="mediaUrl" />
      </a>
    </span>

    <b-modal v-model="showModal" :title="model.name || ''" centered size="lg" hide-footer>
      <b-img :src="model.url" />
    </b-modal>
  </div>
</template>

<script>
import imagePreview from '@/components/common/image-preview'
export default {
  components: {
    imagePreview
  },
  props: {
    value: { type: null, default: '' }
  },
  data() {
    return {
      showModal: false
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(model) {
        this.$emit('input', model)
      }
    },
    mediaUrl() {
      return this.model.thumbnail ? this.model.thumbnail.url : this.model.url
    }
  },
  watch: {
    model(val) {
      this.$emit('input', val)
    },
    value(val) {
      this.model = val
    }
  },
  methods: {
    displayMedia(show) {
      this.showModal = show
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

.wrapper {
  height: 8rem;
  width: 15rem;
  position: relative;
  overflow: hidden;
  margin-right: $spacing-sm;
  flex: 0 0 auto;
  justify-content:center;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

div.wrapper img {
  position: relative;
  top: -1px;
  left: -1px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/media/image-preview.vue